import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Gallery from '../components/Gallery';
import ImageModal from '../components/ImageModal';
import placeholderData from '../data/placeholderData';
import '../styles/home.css';

function Home() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedPhotoId = searchParams.get('photo');

  // Find the selected photo
  const selectedPhoto = selectedPhotoId
    ? placeholderData.find(photo => photo.id === selectedPhotoId)
    : null;

  // Find current index for navigation
  const currentIndex = selectedPhoto
    ? placeholderData.findIndex(photo => photo.id === selectedPhotoId)
    : -1;

  const handleCardClick = (photo) => {
    setSearchParams({ photo: photo.id });
  };

  const handleCloseModal = () => {
    setSearchParams({});
  };

  const handleNextPhoto = () => {
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % placeholderData.length;
    setSearchParams({ photo: placeholderData[nextIndex].id });
  };

  const handlePrevPhoto = () => {
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + placeholderData.length) % placeholderData.length;
    setSearchParams({ photo: placeholderData[prevIndex].id });
  };

  return (
    <main className="home-page">
      <Gallery
        galleryData={placeholderData}
        onCardClick={handleCardClick}
        folder="photography"
      />

      {selectedPhoto && (
        <ImageModal
          photo={selectedPhoto}
          onClose={handleCloseModal}
          onNext={handleNextPhoto}
          onPrev={handlePrevPhoto}
          folder="photography"
        />
      )}
    </main>
  );
}

export default Home;
